import axios from "axios";

const endpoint_url = "/message/whatsappAnalytic/syncAnalytics";

const syncAnalytics = ({whatsappMessageTemplateUuid, startDate = null, endDate = null}) => {
  const params = new URLSearchParams([['whatsapp_message_template_uuid', whatsappMessageTemplateUuid]]);

  if(startDate){
    params.append("start_date", startDate)
  }

  if(endDate){
    params.append("end_date", endDate)
  }

  return new Promise((resolve, reject) => {
    axios
      .get(endpoint_url, { params })
      .then((response) => resolve(response))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default syncAnalytics;
